import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { CarsQueueIcon } from '../../../../../../common/icons';

import AirModal from '../../../../../../common/components/AirModal';
import AirButton from '../../../../../../common/components/AirButton';
import AirRadioGroup from "../../../../../../common/components/AirRadioGroup";
import AirRadio from "../../../../../../common/components/AirRadio";

import './AddToGroupModal.css';

@inject('translationsStore', 'groupsStore', 'commonStore')
@observer
export default class AddToGroupModal extends Component
{
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      groupId: undefined
    };
  }

  show = () => {
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({ visible: false });
  };

  onChange = (e) => {
    this.setState({ groupId: e.target.value });
  };

  render() {
    const { translationsStore, groupsStore, selectedRows, handleAddSelectedRowsToGroup } = this.props;
    const { visible, groupId } = this.state;
    const groups = groupsStore.groups || [];
    const disabled = typeof groupId === 'undefined';

    const vehiclesString = selectedRows.length === 1 ? `1 ${translationsStore.translate('vehicle')}` : `${selectedRows.length} ${translationsStore.translate('vehicles')}`;

    return (
      <AirModal
        className="AddToGroupModal"
        visible={visible}
        icon={<CarsQueueIcon style={{ width: '60px', height: '40px' }} />}
        onCancel={this.hide}
        okButton={<AirButton disabled={disabled} size="large" light label={translationsStore.translate('groupsManager.assignToGroup.modal.buttonLabel')} />}
        onOk={() => !disabled && handleAddSelectedRowsToGroup(groupId)}
        title={translationsStore.translate('groupsManager.assignToGroup.modal.title')}
        subtitle={translationsStore.translate('groupsManager.assignToGroup.modal.subtitle').replace('__N_VEHICLES__', vehiclesString)}
      >
        <div style={{overflowY: 'auto', maxHeight: '280px', overflowX: 'hidden'}}>
          <AirRadioGroup onChange={this.onChange}>
            {
              groups
                .filter(group => !(!!this.props.group && !!this.props.group.id && this.props.group.id === group.id))
                .map((group, index) => <AirRadio key={index} label={group.name} value={group.id} />)
            }
          </AirRadioGroup>
        </div>
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/AddToGroup/AddToGroupModal/AddToGroupModal.js